/**
 * Yaxle type scale as Chakra `textStyles`.
 *
 * Use via `<Text textStyle="body">` / `<Heading textStyle="h2">` instead of
 * ad-hoc fontSize/lineHeight props. Sizes are rem (track the fluid root);
 * line-heights are unitless so they stay proportional to the type size.
 * Use `em` only for tracking that should follow the element's own font-size.
 */
import { fonts } from './tokens/typography';

export const textStyles = {
	// Display / Headings (Geist)
	h1: {
		fontFamily: fonts.heading,
		fontWeight: 700,
		fontSize: '4.5rem',
		lineHeight: 1.07,
		letterSpacing: '-0.02em',
	},
	h2: {
		fontFamily: fonts.heading,
		fontWeight: 700,
		fontSize: '3rem',
		lineHeight: 1.1,
		letterSpacing: '-0.01em',
	},
	h3: {
		fontFamily: fonts.heading,
		fontWeight: 700,
		fontSize: '2rem',
		lineHeight: 1.16,
		letterSpacing: '-0.005em',
	},
	// Section headings (Geist SemiBold)
	h4: {
		fontFamily: fonts.body,
		fontWeight: 600,
		fontSize: '1.5rem',
		lineHeight: 1.08,
	},
	h5: {
		fontFamily: fonts.body,
		fontWeight: 600,
		fontSize: '1.125rem',
		lineHeight: 1.11,
	},
	overline: {
		fontFamily: fonts.body,
		fontWeight: 600,
		fontSize: '0.875rem',
		lineHeight: 1.07,
		letterSpacing: '0.05em',
		textTransform: 'uppercase',
	},
	// Body (Geist Regular)
	bodyLarge: {
		fontFamily: fonts.body,
		fontWeight: 400,
		fontSize: '1.125rem',
		lineHeight: 1.33,
	},
	body: {
		fontFamily: fonts.body,
		fontWeight: 400,
		fontSize: '1rem',
		lineHeight: 1.375,
	},
	// Dense UI copy: settings descriptions, table cells, field labels
	bodySm: {
		fontFamily: fonts.body,
		fontWeight: 400,
		fontSize: '0.875rem',
		lineHeight: 1.43,
	},
	labelSm: {
		fontFamily: fonts.body,
		fontWeight: 500,
		fontSize: '0.875rem',
		lineHeight: 1.43,
	},
	// Secondary lines in dense feeds (activity timelines, sidebar previews)
	caption: {
		fontFamily: fonts.body,
		fontWeight: 400,
		fontSize: '0.75rem',
		lineHeight: 1.33,
	},
	// Mono (IBM Plex Mono)
	labelMono: {
		fontFamily: fonts.mono,
		fontWeight: 500,
		fontSize: '0.75rem',
		lineHeight: 1,
		letterSpacing: '0.05em',
	},
	footerMono: {
		fontFamily: fonts.mono,
		fontWeight: 400,
		fontSize: '0.6875rem',
		lineHeight: 1,
		letterSpacing: '0.18em',
	},
	// Interactive
	cta: {
		fontFamily: fonts.body,
		fontWeight: 600,
		fontSize: '1.25rem',
		lineHeight: 1,
		letterSpacing: '0.01em',
	},
} as const;

export default textStyles;
